import { useTranslation } from 'react-i18next'

const AdultStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="adult-start-title"
      {...props}
    >
      <title id="adult-start-title">{t('antagonists:adult:components:start')}</title>
      <defs>
        <clipPath id="b">
          <path
            d="m1577.69 278.74 11.21 22.8s55.35 20.46 51.01 39.25c-4.33 18.78-18.37 87.58-19.81 116.48-1.44 28.9-4.06 99.57-4.06 99.57s-16.86 39.59-52.26 55.49c-35.4 15.89-78.78-6.96-93.23-13.46-14.45-6.5-18.78-23.12-18.78-23.12s20.95-46.96 21.67-77.3c.72-30.34-10.84-140.88-13.73-153.16-2.89-12.28-9.39-23.84 5.78-32.51 15.17-8.67 45.86-15.61 45.86-15.61l14.11-21.96 52.23 3.53Z"
            style={{
              fill: '#3b9bd2',
            }}
          />
        </clipPath>
        <clipPath id="c">
          <path
            d="M1459.56 317.95c-14.84 14.08-21.69 89.42-25.87 117.19-4.19 27.78-11.42 91.32-9.13 122.14 2.28 30.82 8.02 58.76 8.02 58.76s5.41-2.1 14.8-5.08c10.94-3.47 22.3-2.21 22.3-2.21s-7.16-28.7-6.4-35.55c.76-6.85 4.51-67.61 5.65-88.54 1.14-20.93 10.05-55.24 10.05-55.24l-3.42-105.4-15.98-6.09Z"
            style={{
              fill: '#3b9bd2',
            }}
          />
        </clipPath>
        <clipPath id="d">
          <path
            d="m1567.05 462.64 16.11-27.1s41.92 14.62 55.76 18.6c13.84 3.98 38.23 7.55 38.23 7.55s10.46 42.02-8.25 44.55c-13.83 1.87-42.66-5.01-64.52-20.21-21.86-15.2-37.33-23.39-37.33-23.39Z"
            style={{
              fill: '#3b9bd2',
            }}
          />
        </clipPath>
        <style>
          {
            '.e{fill:#f8f7f0}.f{fill:#f08b27}.g{fill:#ffd500}.h{fill:#d88b46}.i{fill:#dfbe84}.j{fill:#c4c7c9}.k{fill:#c6a4c9}.l{fill:#283a50}.m{fill:#58b6e3}.n{fill:#2e425b}.o{fill:#3b9bd2}.p{fill:#5b3346}.q{fill:#75c6cf}.r{clip-path:url(#c)}.s{clip-path:url(#b)}.t{clip-path:url(#d)}'
          }
        </style>
      </defs>
      <path
        d="M1542.97 263.9s-18.03-.5-21.95 2.34c-3.92 2.83-5.33 11.66-5.82 16.38-.49 4.71-.45 11.11-.45 11.11l39.09 8.67-10.87-38.49Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1518.97 878.44s1.56 30.24 2.44 41.94c.88 11.7 4.05 30.93 4.05 30.93l-36.12 4.05-4.63-10.41s6.78-11.55 6.22-27.64c-.56-16.09-6.42-34.36-6.42-34.36l34.46-4.51Z"
        style={{
          fill: '#ffd500',
        }}
      />
      <path
        d="M1496.19 929.33c9.06.48 12.75 14.09 12.75 14.09s4.49 2.23 9.82-.23c5.34-2.46 3.33-14.92 3.33-14.92l3.51-.73 10.85 40.96s-.08 3.83-13.98 9.74-17.9 7.75-22.23 13.99c-4.32 6.23-14.02 14.11-24.95 14.13-10.93.02-27.14-1.88-27.14-1.88s-2.32-13.27 7.27-23.32c9.59-10.06 11.54-9.34 17.33-18.92 5.79-9.59 5.08-33.86 23.44-32.9Z"
        style={{
          fill: '#f8f7f0',
        }}
      />
      <path
        d="M1606.39 888.52s-7.09 42.83-6.27 52.93c.82 10.09 1.09 17.19.27 17.46-.82.27-29.19-5.18-29.19-5.18s2.73-21.82 3-27.28c.27-5.46 5.18-34.92 5.18-34.92l27.01-3Z"
        style={{
          fill: '#ffd500',
        }}
      />
      <path
        d="M1612.53 533.38c-1.28-3.52 3.9 88.04 5.04 119.91.99 27.52-7.8 96.49-8.68 114.41-.87 17.92 5.09 85.2 4.05 114.3-.88 24.71-6.74 63.26-6.74 63.26s-16.17-.87-22.73-.87c-6.56 0-17.73-4.6-17.73-4.6s-.26-55.09-1.81-88.98c-1.56-34.1-3.78-77.97-5.53-93.7-1.75-15.73-14.27-117.37-14.27-117.37l-12.24-59.01 80.63-47.36Z"
        style={{
          fill: '#c6a4c9',
        }}
      />
      <path
        d="M1549.7 608.57s-15.92 64.72-25.19 97.15c-9.27 32.43-10.69 47.38-8.8 66.98 1.89 19.6 8.25 58.22 9.02 90.13.77 31.91 5.4 63.67 5.4 63.67s-10.41 8.81-24.82 9.55c-14.4.74-20.39-5.08-20.39-5.08s-15.78-127.86-18.71-142.15c-2.93-14.29-3.02-100.94-4.56-122.31-1.54-21.37 8.28-94.09 8.28-94.09l36.58-29.02 43.19 65.17Z"
        style={{
          fill: '#c6a4c9',
        }}
      />
      <path
        d="M1589.2 930.26c8.69.89 15.28 11.19 14.46 19.1-.82 7.91 3.55 23.46 6.55 30.28s-1.09 24.01-1.09 24.01-12 7.37-24.83 6c-12.82-1.36-23.19-2.18-24.01-9.82-.82-7.64 7.91-18.01 7.37-27.28-.55-9.28-4.64-11.73-1.91-19.92 2.73-8.18 7.37-12 7.37-12s2.73-11.73 16.1-10.37Z"
        style={{
          fill: '#f8f7f0',
        }}
      />
      <path
        d="m1577.69 278.74 11.21 22.8s55.35 20.46 51.01 39.25c-4.33 18.78-18.37 87.58-19.81 116.48-1.44 28.9-4.06 99.57-4.06 99.57s-16.86 39.59-52.26 55.49c-35.4 15.89-78.78-6.96-93.23-13.46-14.45-6.5-18.78-23.12-18.78-23.12s20.95-46.96 21.67-77.3c.72-30.34-10.84-140.88-13.73-153.16-2.89-12.28-9.39-23.84 5.78-32.51 15.17-8.67 45.86-15.61 45.86-15.61l14.11-21.96 52.23 3.53Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <g
        style={{
          clipPath: 'url(#b)',
        }}
      >
        <path
          d="m1592.56 298.61-33.31 27.46-13.35-17.29-17.33 16.17-20.67-33.26s12.47-29.11 13.17-29.34 63.53.92 63.53.92l7.96 35.35Z"
          style={{
            fill: '#58b6e3',
          }}
        />
      </g>
      <path
        d="M1618.78 317.15s22.27 8.41 31.03 25.53c8.75 17.12 31.09 119.26 29.19 137.91-1.9 18.64-8.26 12.01-20.44 12.39-12.18.38-20.93-6.85-27.78-28.54-6.85-21.69-25.87-78.76-25.87-78.76l13.87-68.53Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <path
        d="M1468.13 607.75s5.31 6.41 6.04 10.99c.73 4.58-.18 15.2 0 19.6.18 4.4.18 12.64.18 12.64s-6.23-.18-7.87-4.58c-1.65-4.4-.73-18.5-2.2-18.5-1.47 0-.37 15.38.55 19.96s6.04 7.69 7.69 10.62c1.65 2.93 1.47 5.86 1.47 5.86l-14.47-.92s-9.89-5.86-14.28-8.06c-4.4-2.2-7.51-5.49-9.34-8.61-1.24-2.11-2.38-16.85-2.38-16.85l.73-18.13s10.62-3.66 17.58-3.66 16.3-.37 16.3-.37Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1459.56 317.95c-14.84 14.08-21.69 89.42-25.87 117.19-4.19 27.78-11.42 91.32-9.13 122.14 2.28 30.82 8.02 58.76 8.02 58.76s5.41-2.1 14.8-5.08c10.94-3.47 22.3-2.21 22.3-2.21s-7.16-28.7-6.4-35.55c.76-6.85 4.51-67.61 5.65-88.54 1.14-20.93 10.05-55.24 10.05-55.24l-3.42-105.4-15.98-6.09Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <g
        style={{
          clipPath: 'url(#c)',
        }}
      >
        <path
          d="M1402.07 602.63s29.49-9.83 48.49-11.8c19-1.97 39.97 1.97 38.01 1.97-1.97 0 0 36.04 0 36.04l-83.22 13.76-3.28-39.97Z"
          style={{
            fill: '#58b6e3',
          }}
        />
      </g>
      <path
        d="M1579.19 253.82s-.83 7.92-.5 19.02c.33 11.1-2.51 15.93-4.98 19.48-2.47 3.55-28.01 15.08-28.01 15.08s-16.02-10.1-20.65-14.98c-4.63-4.88-4.13-35.86-4.13-35.86l58.27-2.74Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1566.72 172.22c-20.01-2.54-37.43 8.97-42.15 21.06-8.2 20.98-5.21 40.77-5.21 40.77s75.42 8.36 74.4 8.17 6.86-25.97 6.46-37.71c-.4-11.74-12.77-29.67-33.49-32.3Z"
        style={{
          fill: '#f08b27',
        }}
      />
      <path
        d="M1560.15 204.87c-18.33 6.36-35.21-.99-39.39 23.24-2.09 12.11-1.99 25.05.35 36.28 2.33 11.23 6.9 20.75 13.72 26.03 13.65 10.56 19.8 5.18 29.58.63 9.78-4.55 15.21-15.06 19.42-25.5 4.21-10.43 4.58-31.27 6.03-42.37 1.45-11.1 1.27-21.58-5.86-23.97-7.13-2.38-15.67 2.82-23.84 5.65Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1585.03 245.16s5.86-13.61 13.84-9.26c7.98 4.36-2.45 20.61-4.69 25.34-2.24 4.74-3.97 4.26-6.57 2.72-2.59-1.54-6.59-5.31-6.59-5.31l4.02-13.5ZM1524.31 228.61s-2.66-6.1-6.17-4.32c-3.51 1.77-1.49 10.48-2.95 16.73-1.46 6.25-.13 11.34 3.21 12.11 3.34.77 5.77-.9 5.77-.9l.13-23.61Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1558.64 233.64s13.7-5.79 18.15-4.23c4.45 1.56 5.99 4.2 5.99 4.2l-1.28 1.71s-3.34-2.45-7.81-1.21c-4.47 1.24-13.9 3.93-13.9 3.93l-1.16-4.41ZM1546.58 231.79s-6.97-7.37-11.61-7.8c-4.64-.42-8.97 1.59-8.97 1.59l-.06 2.62s4.59-2.99 9.21.32c4.62 3.31 9.43 6.43 9.43 6.43l2.01-3.17ZM1560.65 239.78l12.76 1.04.01-2.94-12.69.33-.08 1.57zM1528.54 232.51l12.08 3.23.47-1.57-11.13-4.46-1.42 2.8z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1535.11 233.3c-2.07-.25-3.7.97-3.87 3.01-.17 2.04 1.05 3.03 2.9 3.37 2.18.4 3.6-.77 3.98-2.85.27-1.47-.87-3.27-3.01-3.53ZM1567.32 238.62c-2.07-.25-3.7.97-3.87 3.01-.17 2.04 1.05 3.03 2.9 3.37 2.18.4 3.6-.77 3.98-2.85.27-1.47-.87-3.27-3.01-3.53Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1543.34 333.95c-1.22.08-2.02.95-1.9 2.14.12 1.19.93 1.62 2.02 1.62 1.3 0 1.98-.83 1.98-2.06 0-.87-.85-1.78-2.11-1.7ZM1537.37 375.7c-1.22.08-2.02.95-1.9 2.14.12 1.19.93 1.62 2.02 1.62 1.3 0 1.98-.83 1.98-2.06 0-.87-.85-1.78-2.11-1.7ZM1537.41 412.56c-1.22.08-2.02.95-1.9 2.14.12 1.19.93 1.62 2.02 1.62 1.3 0 1.98-.83 1.98-2.06 0-.87-.85-1.78-2.11-1.7ZM1535.55 448.99c-1.22.08-2.02.95-1.9 2.14-.04-.39-.49 1.63 2.02 1.62 1.3 0 1.98-.83 1.98-2.06 0-.87-.85-1.78-2.11-1.7ZM1535.37 490.24c-1.22.08-2.02.95-1.9 2.14-.04-.39-.49 1.63 2.02 1.62 1.3 0 1.98-.83 1.98-2.06 0-.87-.85-1.78-2.11-1.7ZM1535.94 530.61c-1.22.08-2.02.95-1.9 2.14-.04-.39-.49 1.63 2.02 1.62 1.3 0 1.98-.83 1.98-2.06 0-.87-.85-1.78-2.11-1.7Z"
        style={{
          fill: '#75c6cf',
        }}
      />
      <path
        style={{
          fill: '#c6a4c9',
        }}
        d="m1529.73 626.25 5.37-54.41 21.21 43.61-26.58 10.8z"
      />
      <path
        d="m1567.05 462.64 16.11-27.1s41.92 14.62 55.76 18.6c13.84 3.98 38.23 7.55 38.23 7.55s10.46 42.02-8.25 44.55c-13.83 1.87-42.66-5.01-64.52-20.21-21.86-15.2-37.33-23.39-37.33-23.39Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <g
        style={{
          clipPath: 'url(#d)',
        }}
      >
        <path
          d="M1601.28 427.66s-5.24 15.73-11.14 26.21-18.35 32.77-18.35 32.77-38.01-26.21-37.35-28.18 38.66-52.42 36.7-52.42 30.14 21.62 30.14 21.62Z"
          style={{
            fill: '#58b6e3',
          }}
        />
      </g>
      <path
        d="M1533.84 270.47c-.16 1.6 1.65 1.55 4.31 3.1 2.07 1.21 4.6 3.14 7.61 3.58 3.29.48 5.71-.24 8.48-1.14 3.01-.98 5.6-1.68 6.1-2.94.51-1.26-8.92-3.82-10.3-3.67s-3.59 1.1-3.59 1.1-.36-1.69-3.69-2.04c-3.33-.34-8.76.41-8.92 2.01Z"
        style={{
          fill: '#d88b46',
        }}
      />
      <path
        d="M1630.26 326.88s11.03-.76 19.79 16.36c8.75 17.12 30.44 112.63 28.54 131.27-1.9 18.64-7.61 18.64-19.79 19.03s-20.93-6.85-27.78-28.54c-6.85-21.69-25.87-78.76-25.87-78.76l25.11-59.36Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <path
        d="m1530.89 292.65 1.98 20.83 9.23 5.57s-5.38 83.12-11.65 105.72c-6.27 22.61-12.08 80.11-13.37 96.23-1.29 16.11.74 61.68.74 61.68l-13.05.98-.52 16.58s-15.71-1.2-37.03-3.37-38.24-3.46-38.24-3.46 12.23-46.45 18.16-80.03 9.84-67.32 13.13-88.14c3.29-20.82-6.3-108.75.06-112.29 6.36-3.55 52.79-21.32 52.79-21.32s1.35-16.92 3.19-19.61c1.84-2.69 4.37-5.35 4.37-5.35s-4.44 6.16-.89 12.52c3.55 6.36 11.09 13.45 11.09 13.45Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1455.58 352.3 50.46 17.82-10.82 23.87-43.75-15.66 4.11-26.03zM1473.77 515.11s-5.61 49.82-6.96 56.6c-1.35 6.78-5.57 8.88-14.5 8.98-8.93.1-20.81-.94-20.81-.94s-6.55-21.92-3.15-39.08c3.4-17.16 10.38-48.63 10.38-48.63l35.05 23.07Z"
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1432.86 514.67 47.52 5.16 5.24-29.99-48.39-4.41-4.37 29.24z"
      />
      <path
        d="M1469.76 506.34c-2.7-.1-4.24 2.17-4.37 3.79-.13 1.62.41 4.24 3.56 4.62 3.35.41 4.26-1.56 4.9-3.61.64-2.05-.98-4.69-4.09-4.8ZM1490.62 380.33c-2.39-.09-3.75 1.92-3.87 3.35s.36 3.75 3.15 4.09c2.97.36 3.77-1.38 4.33-3.19s-.87-4.15-3.62-4.25ZM1564.05 446.26c-2.65.12-3.98 2.45-3.98 4.04s.73 4.11 3.84 4.24c3.31.14 4.04-1.86 4.51-3.91.46-2.05-1.33-4.51-4.37-4.37ZM1585.71 501.26c-2.65.12-3.98 2.45-3.98 4.04 0 1.59.73 4.11 3.84 4.24 3.31.14 4.04-1.86 4.51-3.91s-1.33-4.51-4.37-4.37ZM1459.93 368.91c-1.82-.45-3.33 1.3-3.75 2.67-.42 1.37-.59 3.69 1.47 4.45 2.19.8 3.21-.77 4.07-2.44.85-1.68.3-4.16-1.79-4.67Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="M1429.93 420.04c-14.22 3.2-15.04 57.2-15.78 74.85-2.07 49.46 14.39 116.99 14.39 116.99s11.65-5.41 21.54-8.19c9.48-2.67 19.85-3.26 19.85-3.26s-12.07-65.36-11.95-83.28c.11-17.93-4.67-102.36-28.03-97.1Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1458.22 314.26c-21.99 15.06-40.69 114.23-42.46 132.62-1.77 18.39-.87 39.41-.69 47.3.18 7.89 19.93-1.42 29.4-2.11 9.47-.69 18.21-6.39 22.03-20.28 3.82-13.9-1.18-64.17 4.36-91.73 5.54-27.55 13.26-62.45 12.52-67.19-.74-4.74-15.78-5.05-25.18 1.39ZM1578.16 288.66c-.7 5.29-3.02 7.89-7.65 11.41-6.96 5.29-11.55 10.57-11.55 10.57l-8.03 18.95s-3.21 99.23 2.3 123.47c5.52 24.24 64.26 148.8 64.26 148.8l37.53-23.58s-23.39-60.08-31.76-74.1c-8.12-13.62-5.32-48.77 2.47-80.29 7.8-31.52 25.74-84.04 18.31-92.61-7.43-8.57-23.95-16.42-34.77-22.39-10.82-5.97-20.09-9.8-20.09-9.8s-7.4-19.28-9.49-19.63c-.83-.14-1.01 5.23-1.53 9.18Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="m1577.23 386.35 8.39 25.45s28.57-9.99 36.46-10.86c7.9-.87 18.31-3.7 17.83-3.59s-5.56-27.39-5.56-27.39-17.9 4.36-31.96 7.66c-14.05 3.3-25.17 8.73-25.17 8.73Z"
        style={{
          fill: '#283a50',
        }}
      />
      <path
        d="M1643.45 330.2c-18.42-15.33-16.82 64.79-25.76 87.16-1.76 4.41 11.2 44.06 13.84 53.32 2.51 8.8 1.7 33.33 1.7 33.33s37.2 19.77 45.71-5.71c8.31-24.87-4.86-76.59-9.32-97.66-4.16-19.66-19.21-64.63-26.18-70.44Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1591.89 396.85c-2.39-.11-3.77 1.89-3.89 3.32-.13 1.43.33 3.75 3.12 4.12 2.96.39 3.78-1.35 4.36-3.16.58-1.81-.83-4.15-3.58-4.28ZM1564.74 445.76c-2.13-.1-3.36 1.68-3.47 2.96-.11 1.27.29 3.34 2.78 3.67 2.64.35 3.37-1.2 3.89-2.81s-.74-3.7-3.2-3.81ZM1583.39 496.52c-2.13-.1-3.36 1.68-3.47 2.96-.11 1.27.29 3.34 2.78 3.67 2.64.35 3.37-1.2 3.89-2.81s-.74-3.7-3.2-3.81Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1556.38 330.25 14.82 14.83 11.68.45-.45-9.44-19.76-19.76-6.29 13.92z"
      />
      <path
        d="M1565.83 325.99c-1.75-.08-2.75 1.38-2.84 2.42-.09 1.04.24 2.74 2.28 3.01 2.17.28 2.76-.98 3.18-2.3.42-1.32-.61-3.03-2.62-3.12ZM1575.74 333.57c-1.75-.08-2.75 1.38-2.84 2.42-.09 1.04.24 2.74 2.28 3.01 2.17.28 2.76-.98 3.18-2.3.42-1.32-.61-3.03-2.62-3.12Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="M1617.46 454.88a1.23 1.23 0 0 0-.65-1.59s-33.81-14.62-35.8-17.97c-1.99-3.35-4.87-6.81-6.4-10.3-1.53-3.49-4.85-9.28-8.4-10.81-2.35-1.01-8.32.62-11.19-.74-2.87-1.36-21.35-10.69-24.44-12.36s-12.36-6.31-14.04-2.85c-1.68 3.46-.8 3.94 3.02 6.01 3.82 2.07 4.72 2.17 6.84 3.51 2.12 1.34 14.7 8.23 14.3 8.97-.4.73-1.78-.58-3.63-1.01-1.85-.43-3.07.05-4.33 2.03-1.26 1.98-.44 4.32.94 5.64 1.38 1.32 0 0-1.52.7s-3.03 3.49-2.54 4.7c.48 1.21 3.63 3.48 3.23 4.22-.4.73-1.95.09-2.73 1.18-.78 1.1-1.12 2.43-.77 3.19.35.76.69 1.89 1.7 2.82 1.02.93 9.71 7.34 15.21 10.51 5.51 3.17 14.85 5.56 19.36 7.06 4.51 1.49 40.23 22.07 40.23 22.07.57.34 1.25.11 1.51-.5l10.09-24.46Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1650.11 565.68s-2.1 2.15-6.96 4.18c-3.45 1.44-7.02 3.41-11.48-5.91-4.46-9.32-17.48-39.99-17.48-39.99l16.04-5.97 19.88 47.7Z"
        style={{
          fill: '#283a50',
        }}
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1631.67 517.97-20.28 9.6-9.96-28.72 19.18-8.3 11.06 27.42z"
      />
      <path
        d="M1619.86 511.28c2.44-.6 4.15 1.45 4.49 3.09.34 1.64.22 4.44-2.59 5.42-2.98 1.05-4.08-.82-4.94-2.81-.86-1.99.24-5.01 3.04-5.7Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="M1663.46 461.53c-10.46-4.3-25.88-6.89-41.64-15.51-15.76-8.62-34.04-12.16-34.04-12.16l-24.72 30.8s28.92 21.9 45.79 28.37c16.87 6.46 19.66 10.85 31.86 14.21 12.21 3.36 29.92-.36 33.46-11.39 7-21.78 2.49-28.89-10.72-34.32Z"
        style={{
          fill: '#2e425b',
        }}
      />
    </svg>
  )
}

export default AdultStart

